// extracted by mini-css-extract-plugin
export default {"services":"Services_services__ewkyS"};